import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import { resolveBaseAppearance } from './theme';
import type { BaseVisuallyHiddenProps } from './types';
import { cn } from './utils';

export const BaseVisuallyHidden = forwardRef<
  HTMLSpanElement,
  BaseVisuallyHiddenProps
>(function BaseVisuallyHidden(
  {
    children,
    focusable = false,
    appearance,
    className,
    classNames,
    style,
    ...hiddenProps
  },
  ref,
) {
  const resolvedAppearance = useMonkeysBaseAppearance(appearance);
  const componentAttributes = useMonkeysComponentAttributes();
  const theme = resolveBaseAppearance(resolvedAppearance);

  if (typeof focusable !== 'boolean') {
    throw new TypeError('BaseVisuallyHidden focusable must be a boolean.');
  }

  return (
    <span
      {...componentAttributes}
      {...hiddenProps}
      ref={ref}
      data-monkeys-component="visually-hidden"
      data-slot="root"
      data-focusable={focusable || undefined}
      className={cn(
        theme.slots.visuallyHiddenRoot,
        focusable && theme.slots.visuallyHiddenFocusable,
        classNames?.root,
        className,
      )}
      style={{
        ...theme.styles.visuallyHidden,
        ...style,
      }}
    >
      {children}
    </span>
  );
});
